import { render, staticRenderFns } from "./Icon.vue?vue&type=template&id=6bcc09bc&scoped=true"
import script from "./Icon.vue?vue&type=script&setup=true&lang=ts"
export * from "./Icon.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Icon.vue?vue&type=style&index=0&id=6bcc09bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bcc09bc",
  null
  
)

export default component.exports